const exception = {
    path: '/abnormal',
    name: 'Abnormal',
    icon: 'iconyinhuanguanli',
    redirect: '/abnormal/abnormalcause',
    component: () =>
        import('@/pages/layout/appMain'),
    children: [
        // //异常原因
        {
            name: 'ExReason',
            path: '/abnormalcause',
            component: () =>
                import('@/pages/abnormal/abnormalCause/AbnormalCause.vue')
        },
         //无效异常规则
         {
            icon: 'el-icon-remove-outline',
            name: 'invalidRule',
            path: '/invalidRule',
            component: () =>
                import('@/pages/abnormal/invalidRule/invalidRule.vue')
        },
        // 报警记录（从 Application 迁移至 Abnormal）
        {
            icon: '',
            name: 'alarmRecord',
            path: '/alarmRecord',
            hidden: true,
            component: () => import('@/pages/applied/alarmRecord/alarmRecord.vue')
        },
    ]
}

export default exception